<template>
  <div class="artist">
    <!-- {{ $route.query.id }} -->
    <div class="go-back fa fa-history" @click="$router.go(-1)">返回</div>
    <!-- {{$route.query.id}} -->

    <template v-if="playDetail">
      <div class="singer">
        <img :src="playDetail.picUrl" alt="" />
        <div class="detail">
          <h2>{{ playDetail.name }}</h2>
          <h4>单曲：{{ playDetail.musicSize }}</h4>
          <h4>MV：{{ playDetail.mvSize }}</h4>
          <h4>专辑：{{ playDetail.albumSize }}</h4>
        </div>
      </div>
      <h1>歌手简介</h1>
      <p>{{ playDetail.briefDesc }}</p>
    </template>

    <template v-if="playDetail">
      <h1>热门单曲</h1>
      <ul>
        <SongListItem
          v-for="(item, index) in singerHot"
          :key="index"
          :song-item="item"
          :is-show-quality="true"
          :index="index"
          @translate-currentid="$emit('translate-currentid', $event)"
        />
      </ul>
    </template>
  </div>
</template>

<script>
import SongListItem from "@/components/SongListItem.vue";

export default {
  components: {
    SongListItem
  },
  data() {
    return {
      playDetail: null,
      singerHot: null
    };
  },
  methods: {
    // 获取详情数据
    getDetail(id) {
      this.axios
        .get("http://music.kele8.cn/artists", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          // window.console.log(reponse);
          ({ artist: this.playDetail } = reponse.data);
        });
    },
    // 获取歌手热门歌曲
    getSingerHot(id) {
      this.axios
        .get("http://music.kele8.cn/artists", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          // window.console.log(reponse);
          ({ hotSongs: this.singerHot } = reponse.data);
        });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getDetail(to.query.id);
      vm.getSingerHot(to.query.id);
    });
  }
};
</script>

<style lang="less">
.artist {
  .go-back {
    margin-left: 5px;
    font-size: 14px;
    color: #c62f2f;
    // border-bottom: 1px solid #666;
  }
  .singer {
    width: 100%;
    height: 300px;
    position: relative;
    img {
      height: 100%;
      width: 100%;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.2);
      // z-index: 1;
    }
    .detail {
      position: absolute;
      bottom: 10px;
      left: 10px;
      color: #fff;
      font-size: 14px;
      z-index: 1;
      h2 {
        font-size: 20px;
        line-height: 20px;
        padding: 5px 0;
      }
      h4{
        margin-top: 10px;
      }
    }
  }
  h1 {
    font-size: 16px;
    color: #333;
    padding: 15px;
    font-weight: 700;
  }
  p {
    color: #666;
    font-size: 14px;
    line-height: 20px;
    padding: 0 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>
